module.exports = __webpack_public_path__ + "static/viread-illustrations-3-c5e66262f0e110f1929444c03b141f6a.jpg";